import React, { Component } from 'react';
import './ToggleSwitch.css'
class ToggleSwitch extends Component {

    constructor(props) {
        super(props);
        this.toggleChange = this.toggleChange.bind(this);
        this.state = {
            label: props.offLabel
        }
    }

    toggleChange(event) {
        if(event.target.checked){
            this.setState({label: this.props.onLabel});
        }else{
            this.setState({label: this.props.offLabel});
        }
    }
    render() {
        return (
            <>
                <label className="switch">
                    <input type="checkbox" onChange={(event) => this.toggleChange(event)} />
                    <span className="slider round"></span>
                </label>
                <span className ="switch-label">{this.state.label}</span>
            </>
        );
    }
}

export default ToggleSwitch;